import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { endpoints } from '@shared/endpoints';

@Injectable({
    providedIn: 'root',
})
export class SeasonsService {
    constructor(private http: HttpClient) {}

    getAllSeasons() {
        return this.http.get<any>(endpoints.seasons.children.getAllSeasons());
    }
    getSeason(id: string) {
        return this.http.get<any>(endpoints.seasons.children.getSeason(id), {});
    }

    createSeason(id: string, model: any) {
        return this.http.post<any>(
            endpoints.seasons.children.getSeason(id),
            model
        );
    }

    updateSeason(id: string, model: any) {
        return this.http.put<any>(
            endpoints.seasons.children.getSeason(id),
            model
        );
    }

    deleteSeason(id: string) {
        return this.http.delete<any>(endpoints.seasons.children.getSeason(id));
    }

    saveLevels(id: string, model: any) {
        return this.http.put<any>(
            endpoints.seasons.children.getLevels(id),
            model
        );
    }

    getLevels(id: string) {
        return this.http.get<any>(endpoints.seasons.children.getLevels(id));
    }

    saveRewards(id: string, model: any) {
        return this.http.put<any>(
            endpoints.seasons.children.getRewards(id),
            model
        );
    }
}
